var map = {
	"./11_green.mp3": "8be9",
	"./12_purple.mp3": "0b75",
	"./14_orange.mp3": "c404",
	"./9_red.mp3": "8d0c",
	"./M_Brilliant.mp3": "1b7e",
	"./M_Excellent.mp3": "0f53",
	"./M_Fantastic.mp3": "0e2e",
	"./M_Great.mp3": "cbf7",
	"./M_Perfect.mp3": "8ce5",
	"./M_Think again.mp3": "2bc0",
	"./M_Try again.mp3": "cbe0",
	"./M_Very good.mp3": "8fe5",
	"./M_Well done.mp3": "01b7",
	"./M_Work harder.mp3": "4b5e",
	"./click.mp3": "6291",
	"./false.mp3": "6586",
	"./true.mp3": "16c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8cf9";